export interface MetricData {
  totalProjects: number;
  scannedProjects: number;
  avgSecurityScore: number;
  securityScoreDistribution: Record<string, number>;
  avgSecurityBreakdown: Record<string, number>;
  totalSecurityFindings: {
    total: number; critical: number; high: number; medium: number; low: number; info: number;
  };
  totalThreatFindings: { total: number; potential: number; safe: number; mitigated: number };
  totalEpaFindings: {
    total: number; pass: number; fail: number; partial: number;
    critical: number; high: number; medium: number; low: number;
  };
  totalComplianceFindings: { total: number; compliant: number; nonCompliant: number; partial: number };
  aggregatedSpSummary: {
    total: number; yes: number; no: number; partial: number; unknown: number; na: number; needsReview: number;
  };
  complianceFrameworksDistribution: Record<string, number>;
  incidentReadinessDistribution: { high: number; medium: number; low: number };
  aiAppsCount: number;
  crossBorderCount: number;
  top5Projects: Array<{ appId: string; appName: string; score: number }>;
  bottom5Projects: Array<{ appId: string; appName: string; score: number }>;
  incompleteProjects: Array<{ appId: string; projectName: string; reason: string }>;
  peerRanking?: {
    hasPeers: boolean;
    userOrgRank: number | null;
    userOrgScore: number;
    totalOrgs: number;
    rankings: Array<{
      orgId: string; orgName: string; avgScore: number; projectCount: number; isUserOrg: boolean; rank: number;
    }>;
    parentOrgName: string;
  };
  sonarSummary?: {
    appsCount: number;
    totalBugs: number;
    totalVulnerabilities: number;
    totalCodeSmells: number;
    totalHotspots: number;
    issuesBySeverity: { blocker: number; critical: number; major: number };
  };
  blackDuckSummary?: {
    appsCount: number;
    vulnerabilities: { critical: number; high: number; medium: number; low: number; total: number };
    licenseRisk: { high: number; medium: number; low: number };
  };
}

export const ALL_ORG_UNITS = '__all__';

export const DONUT_COLORS = {
  safe: '#10B981',
  mitigated: '#3B82F6',
  potential: '#EF4444',
  compliant: '#10B981',
  nonCompliant: '#EF4444',
  partial: '#F59E0B',
  pass: '#10B981',
  fail: '#EF4444',
};

export const SEVERITY_COLORS: Record<string, string> = {
  critical: '#991B1B',
  high: '#EF4444',
  medium: '#F59E0B',
  low: '#10B981',
};

export function scoreColor(score: number) {
  if (score >= 8) return '#10B981';
  if (score >= 6) return '#F59E0B';
  return '#EF4444';
}
